var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { Store } from "./store";
import { observer } from "mobx-react";
import { Wrapper, Content, Table, TableHead, TableHeadRow, TableHeadCell, TableBody, TableCell, TableCellAlert, TableRow, Loader, } from "./components";
import { ProtableTopBar } from "./top";
import { ProtableControls } from "./controls";
import { ProtableFilters } from "./filters";
import { ProtableExport } from "./export";
import { RotateLoader } from "../../loaders/rotate/index";
import { FaExclamation } from "react-icons/fa";
import { Checkbox } from "../../form/checkbox";
let Protable = class Protable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.store = new Store(props.fetch);
        this.store.update({
            items: props.items,
            count: props.count,
        });
    }
    componentDidMount() {
        this.store.fetch();
    }
    componentDidUpdate() {
        this.store.update({
            items: this.props.items,
            count: this.props.count,
        });
    }
    render() {
        const { screenWidth, columns, query, onClick, exportUrl, rowAlert, onPageChange, region, onChangeRowSelect, selectedRows, exportSettings, openCustomExportModal, filterConfigs, } = this.props;
        const { items, loading, error, dropdown } = this.store.s;
        const showExportButton = !!exportUrl;
        const showExportModule = dropdown === "export";
        return (React.createElement(Wrapper, null,
            React.createElement(Content, null,
                React.createElement(ProtableTopBar, { store: this.store, showExportModule: showExportButton }),
                React.createElement(ProtableFilters, { store: this.store, query: query, region: region, filterConfigs: filterConfigs }),
                React.createElement(ProtableExport, { store: this.store, exportUrl: exportUrl, region: region, exportSettings: exportSettings, openCustomExportModal: openCustomExportModal })),
            !showExportModule && (React.createElement(React.Fragment, null,
                React.createElement(Content, null,
                    React.createElement(Table, null,
                        React.createElement(TableHead, null,
                            React.createElement(TableHeadRow, null,
                                !!onChangeRowSelect && (React.createElement(TableHeadCell, { className: "" })),
                                columns.map((c, i) => {
                                    if (c.hide)
                                        return null;
                                    if (c.breakpoint !== undefined &&
                                        screenWidth < c.breakpoint)
                                        return null;
                                    return (React.createElement(TableHeadCell, { key: i, className: c.className || "" }, c.title));
                                }))),
                        React.createElement(TableBody, null, !loading &&
                            !error &&
                            items.map((item, i) => {
                                const selectedIndex = (selectedRows || []).indexOf(item._id);
                                return (React.createElement(TableRow, { key: i, onClick: () => onClick(item) },
                                    !!onChangeRowSelect && (React.createElement(TableCell, { className: "p-l-3 p-r-3", style: {
                                            width: "42px",
                                        }, onClick: (e) => {
                                            e.stopPropagation();
                                            const selected = [
                                                ...(selectedRows ||
                                                    []),
                                            ];
                                            if (selectedIndex !==
                                                -1) {
                                                selected.splice(selectedIndex, 1);
                                            }
                                            else {
                                                selected.push(item._id);
                                            }
                                            onChangeRowSelect(selected);
                                        } },
                                        rowAlert &&
                                            rowAlert(item) && (React.createElement(TableCellAlert, null,
                                            React.createElement(FaExclamation, null))),
                                        React.createElement(Checkbox, { id: `select-${item._id}`, checked: selectedIndex !==
                                                -1 }))),
                                    columns.map((c, k) => {
                                        if (c.hide)
                                            return null;
                                        if (c.breakpoint !==
                                            undefined &&
                                            screenWidth <
                                                c.breakpoint)
                                            return null;
                                        return (React.createElement(TableCell, { key: k, style: {
                                                width: c.width
                                                    ? `${c.width}px`
                                                    : "auto",
                                            } },
                                            !onChangeRowSelect &&
                                                k === 0 &&
                                                rowAlert &&
                                                rowAlert(item) && (React.createElement(TableCellAlert, null,
                                                React.createElement(FaExclamation, null))),
                                            c.render(item)));
                                    })));
                            }))),
                    loading && (React.createElement(Loader, null,
                        React.createElement(RotateLoader, { size: 4, className: "center" }))),
                    !loading && !error && items.length === 0 && (React.createElement(Loader, null,
                        React.createElement("p", { className: "text-center big" }, "No Items Found"))),
                    !loading && error && (React.createElement(Loader, null,
                        React.createElement("p", { className: "text-center error-text big" }, error)))),
                React.createElement(ProtableControls, { store: this.store, onPageChange: onPageChange }),
                React.createElement("p", { className: "small text-center m-t-2 font-semi-bold" }, "Page")))));
    }
};
Protable = __decorate([
    observer
], Protable);
export { Protable };
//# sourceMappingURL=index.js.map